import { Box, FloatingIndicator, rem } from '@mantine/core';
import { Link, useMatchRoute, useParams } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './result-nav.module.css';

const DETAIL_VIEWS = ['table', 'map'] as const;

export function ResultNav() {
  const { id } = useParams({
    from: '/_app/_admin/results_/$id',
  });
  const matchRoute = useMatchRoute();
  const isOnMap = matchRoute({ to: '/results/$id/map' });
  const isOnTable = matchRoute({ to: '/results/$id/table' });
  const { t } = useTranslation();

  const [rootRef, setRootRef] = useState<HTMLDivElement | null>(null);
  const [controlsRefs, setControlsRefs] = useState<
    Record<number, HTMLAnchorElement | null>
  >({});

  const active = isOnTable ? 0 : isOnMap ? 1 : 0;

  const setControlRef = (index: number) => (node: HTMLAnchorElement | null) => {
    setControlsRefs((prev) => ({ ...prev, [index]: node }));
  };

  const controls = DETAIL_VIEWS.map((item, index) => (
    <Link
      className={classes.control}
      key={item}
      params={{ id }}
      ref={setControlRef(index)}
      to={`/results/$id/${item}`}
    >
      <span className={classes.controlLabel}>
        {t(`sampling.results.nav.${item}`)}
      </span>
    </Link>
  ));

  return (
    <Box className={classes.root} h={rem(36)} ref={setRootRef}>
      {controls}

      <FloatingIndicator
        className={classes.indicator}
        parent={rootRef}
        target={controlsRefs[active]}
      />
    </Box>
  );
}
